/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Owner_BadgeInputs */



/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Team_Manager_Owner_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_owner_badge = /** @type {((inputs?: Team_Manager_Owner_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Owner_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Propriétaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhaber")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proprietario")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Владелец")
	if (locale === "es") return /** @type {LocalizedString} */ ("Propietario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーナー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मालिक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Proprietário")
	return /** @type {LocalizedString} */ ("Owner")
});